export function isOnlyNumbers(str) {
  return /^\d+$/.test(str);
}

export function isOnlyLetters(str) {
  return /^[A-zÀ-ÿ]*$/g.test(str);
}

export function isEmail(email) {
  var re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

export function isEmpty(value) {
  return !!value ? value.length === 0 : false;
}

export function isBiggerThanMaxLength(value, maxLength) {
  return !!value ? value.length > maxLength : false;
}

export function isLowerThanMinLength(value, minLength) {
  return !!value ? value.length < minLength : false;
}

export function isEqual(value1, value2) {
  return !!value1 && value2 ? value1 === value2 : false;
}



// WEBPACK FOOTER //
// ./src/components/support/validation/index.js